module.exports = __webpack_public_path__ + "img/reposicion-redes (3).defc9d78.jpg";